module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/elements/spinners-84e614244e5b871ca3d8be98da0c828c.svg";